import {
  Button,
  ButtonColor,
  ButtonWidth,
} from '@leland-dev/leland-ui-library';
import React from 'react';

interface Round2CoachesBannerProps {
  className?: string;
  onClick?: () => void;
}

export const Round2CoachesBanner: React.FC<Round2CoachesBannerProps> = ({
  className = '',
  onClick,
}) => {
  const href =
    'https://www.joinleland.com/library/a/round-2-mba-admissions-coaches';

  return (
    <div
      className={`flex flex-col items-center justify-between overflow-hidden rounded-xl bg-leland-gray-hover p-6 leading-snug md:flex-row ${className}`}
    >
      <div className="flex flex-col items-center space-y-4 md:mr-4 md:flex-row md:space-x-4 md:space-y-0">
        <p className="text-4xl">🔥</p>
        <div className="flex flex-col">
          <h3 className="mr-0 text-center text-lg font-medium md:mr-4 md:text-left">
            Need last-minute help with your Round 2 applications?
          </h3>
          <p className="text-center text-leland-gray-light md:text-left">
            Here are 15 coaches who are ready to help.
          </p>
        </div>
      </div>

      <a
        className="mt-4 w-full md:mt-0 md:w-min"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        <Button
          label="See coaches"
          buttonColor={ButtonColor.PRIMARY}
          width={ButtonWidth.FULL_MOBILE}
        />
      </a>
    </div>
  );
};
